// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.sign-in-button-container {
  display: flex;
  min-height: 100vh;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.login-page2 {
  position:absolute;
  top:50%;
  left:50%;
  margin-top:-50px;
  margin-left:-100px;
  height: 30vh;
  width: 50vh;
  border: #282c34 1px solid;
  background-color: #F7F7F7;
}

.login-page {
  height: 100vh;
  width: 100%;
  background-color: #F7F7F7;
}

.cch_logo_login {
  top: 40px;
  left: 25px;
  width: 180px;
  height: auto;
  position: fixed;
}

.edge_logo_login {
  top: 40px;
  right: 40px;
  width: 180px;
  height: auto;
  position: fixed;
}

.login-box{
  width: 350px;
  height: 260px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #F7F7F7;
  border-radius: 8px;
  box-shadow: 5px 5px 17px #ccc;
}

.login-box-header{
  height: 35%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.login-page-logo{
  height: 38%;
  width: 38%;
  margin: 5% 0% 0% 5%;
}

.login-box-body{
  height: 65%;
}

.login-box-body label{
  font-weight: 600;
  font-size: large;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number] {
  -moz-appearance: textfield;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.sidebar p{
  font-family: 'Montserrat';
  font-size: medium;
  font-weight: 600;
}

.sidebar:hover{
  background-color: #EBEBEB;
  color:#606060;
  font-weight: 700;
  font-size: 28;
  text-decoration: none !important;
}

.navLinks:hover{
  background-color: #EBEBEB;
  color:#606060; 
  text-decoration: none;
  text-emphasis: none;
}

.navLinks{
  text-decoration: none;
}

.box-container{
  height: 82px;
  }
  
  .box-container .css-ciy9n4-MuiPaper-root-MuiAppBar-root{
    box-shadow: none !important;
    border-bottom: 3px solid #EBEBEB;
  }
  
  .body-container{
    top: 20px;
    height: auto !important; 
    min-height: calc(100vh - 82px) !important;
  }
  .body-container-sustain{
    top: 20px;
    height: auto !important; 
    min-height: calc(100vh + 10px) !important;
  }

  .loading-home-container{
    top: 20px;
    height: 100% !important; 
    min-height: calc(100vh - 82px) !important;
  }
  
  .navbar-company-icon{
    width: 8.5rem;
    padding: 0px 2px;
  }
  
  .navbar-company-icon img{
    width: 100%;
  }
  
  .navlink-container{
    width: 100%;
    padding-left: 65px;
    display: flex;
    max-width: 80%;
    overflow-x: auto;
    align-items: center;
  }
  
  .navLinks{
    color: #606060;
    padding: 10px 42px;
    /* font-size: 20;  */
    text-decoration: none;
    margin: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .navLinks p{
    margin: 0px;
    padding-top: 5px;
    font-family: 'Montserrat';
    font-size: small;
    font-weight: 600;
    text-align: center;
  }
  
  .navLinks img{
    width: 38px;
  }
  
  .navlink-active{
    border-bottom: 3px solid #E61C2A;
  }

  .navlink-icon{
    color: #9B9595;
  }

  .navlink-active .navlink-icon{
    color: #E61C2A;
  }

  .navlink-active .navlink-text{
    color: #E61C2A;
  }
  
  .landing-header{
    background-color: #F7F7F7 !important;
    color: #606060 !important;
  }
  
  .navbar-logout-container{
    /* position: absolute; */
    right: 24px;
    display: flex;
  }

  .navbar-right-section-icon{
    padding: 10px 20px;
    color: #E61C2A;
    cursor: pointer;
  }

  .sidebar-color{
    background-color: #F7F7F7;
  }

  .sidebar-divider{
    background-color: #EBEBEB;
  }

  .css-1f2xuhi-MuiDrawer-docked .MuiDrawer-paper{
    background-color: #F7F7F7;
  }

  .css-3v9zut{
    height: 82px;
  }
  .sidebar-header-title{
    margin: 0px;
    margin-right: auto;
    color: #606060;
    font-family: 'Montserrat';
    font-size: larger;
    font-weight: 600;
  }

  .body-container,.body-container-sustain{
    background-color: #F7F7F7;
    color: #606060;
    font-family: 'Montserrat';
    font-size: larger;
    font-weight: 600;
    padding: 15px 15px;
    width: 100%;
  }

  .user-view-container{
    height: 100%;
    padding: 0% 2%;
  
  }
  
  .user-view-header{
    height: 10vh;
    padding: 0%;
    margin: 0%;
  }

  .user-view-input-layer{
    height: 10vh;
    padding: 0%;
    margin: 0%;
  }

  .user-view-input-layer .navlink-icon {
    color: #E61C2A;
    cursor: pointer;
  }
  
  .country-drop-down {
    cursor: pointer;
    padding: 0px 15px;
    border: none;
    height: 50%;
    width: 80%;
    border-radius: 4px;
    font-size: small;
    color: #000000;
    background-color: #EBEBEB;
    text-decoration: none;
  }

  select {
    outline: 0;
    box-shadow: none;
    text-overflow: ellipsis;
  }
  
  select:focus{
    outline: 0;
    box-shadow: none;
  }
  
  .country-drop-down:hover{
    background-color: #f0efef;
    border-radius: 4px;
  }
  
  .select-dropdown-option{
    background-color: #EBEBEB;
    text-overflow: ellipsis;
  }

  .user-view-text-header{
    font-size: small;
    font-weight: 800;
    text-overflow: ellipsis;
  }

  .user-view-text-value{
    font-size: small;
    font-weight: 200;
    padding-left: 10px;
  }

  .text-input-box {
    padding: 8px;
    height: 40px;
    border: none;
    width: 98%;
    border-radius: 4px;
    color: #606060;
    font-family: inherit;
    font-size: small;
    text-decoration: none;
    text-overflow: ellipsis;
    background-color: white;
    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);
    resize: none;
  }

  .text-input-box:focus {
    outline: 0;
  }

  .text-input-box-disabled {
    padding: 8px;
    height: 40px;
    border: none;
    width: 98%;
    border-radius: 4px;
    color: #606060;
    font-family: inherit;
    font-size: small;
    text-decoration: none;
    text-overflow: ellipsis;
    background-color: #F2F2F2;
    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);
    resize: none;
  }

  .text-input-textarea{
    height: 60px;
    border: none;
    width: 98%;
    border-radius: 4px;
    color: #606060;
    font-family: inherit;
    font-size: small;
    text-decoration: none;
    text-overflow: ellipsis;
    background-color: white;
    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);
    resize: none;
  }

  .text-input-textarea:focus{
    outline: 0;
  }

  .user-view-input-label-text{
    font-size: small;
    font-weight: 580;
    color: black;
     margin-top: 1.5vh; 
    padding-right: 15px;
    text-overflow: ellipsis;
  }

  .user-view-input-label-text-comment{
    font-size: small;
    font-weight: 580;
    color: black;
    margin-top: 1.5vh;
    padding-right: 11px;
    text-overflow: ellipsis;
  }

  .user-view-kbi-unit{
    font-size: small;
    color: black;
    text-overflow: ellipsis;
    font-weight: 580;
    margin-top: 1.5vh;
    padding-left: 15px;
  }
  
  .user-view-input-layer-comment{
    height: 15vh;
    padding: 0%;
    margin: 0%;
    text-overflow: ellipsis;
  }

  .user-view-added-at-container{
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .user-view-added-by-container{
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .form-submit-button{
    background-color: #E61C2A;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 60%;
    width: 10%;
    float: right;
    margin-right: 35px;
  }

  .export-button{
    background-color: #9B9595;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 60%;
    width: 30%;
    float: right;
    margin-right: 35px;
  }

  .user-view-input-layer-submit{
    height: 10vh;
    width: 100%;
  }

  .edit-button-container{
    text-align: end;
  }

  .dialogue-box-container .MuiDialog-paper{
    min-height: 33vh;
    max-width: 33vh;
    min-width: 38vh;
  }

  .MuiDialog-paperWidthSm {
    max-width: none !important;
  }
  
  .dialogue-button-container{
    justify-content: center !important;
    padding: 16px 24px !important;
  }

  .dialogue-button-submit{
    background: #E61C2A !important;
    border-radius: 35px !important;
    height: 5vh !important;
    width: 20vh !important;
    color: white !important;
    font-size: small !important;
    border: none !important;
  }

  .dialogue-button-cancel{
    background: #9B9595 !important;
    border-radius: 35px !important;
    width: 20vh !important;
    color: white !important;
    font-size: x-small !important;
  }
.channel-category-modal{
  align-items: flex;
}
  .dialogue-icon-container{
    justify-content: center;
    text-align: center;
    width: 42px;
    border: 1px #9B9595 solid;
    border-radius: 500px;
    height: 42px;
    margin: auto;
  }

  .dialogue-icon{
    color: #9B9595;
    height: 6vh;
  }

  .dialogue-box-header{
    font-weight: 600 !important;
    
  }
   
  .table-container {
    width: 100% !important;
    min-width: 100%;
    max-width: 100%;
    min-height: 62vh;
    overflow: auto;
    overflow-x: auto;
    margin: 0px !important;
    border-radius: 10px;
    background-color: white;
    box-shadow: 4px 3px 8px 1px #969696;
    text-overflow: ellipsis;
  }
  
  .table-container th{
    color: #E61C2A;
    font-size: small;
    text-overflow: ellipsis !important;
    text-align: center;
  }

  .table-container tr{
    font-size: small;
    font-weight: 200;
    text-overflow: ellipsis !important;
  }

  .table-container td{
    font-size: small;
    font-weight: 200;
    max-width: 20vh;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding-top: 1rem !important;
  }

  tbody{
    font-size: small;
    font-weight: 200;
    text-overflow: ellipsis !important;
    border-top: 1px solid #9B9595;
    overflow-y: scroll;
  }

  .table>:not(:first-child){
    border-top: 0px solid #9B9595;
  }

  .table-data-note{
    width: 100%;
    justify-content: center;
    text-align: center;
    font-size: medium;
    margin-top: 20vh;
  }

  .admin-button-container{
    float: right;
    margin-top: 5vh;
    width: 30%;
    height: 6vh;
 }

  .admin-button-reject{
    border-radius: 60px;
    width: 30%;
    height: 100%;
    background-color: #9B9595;
    color: #F7F7F7;
    font-size: small;
    cursor: pointer;
    border: 1px solid #E61C2A;
  }

  .admin-button-approve{
    border-radius: 60px;
    width: 30%;
    height: 100%;
    background-color: #E61C2A;
    color: #F7F7F7;
    font-size: small;
    cursor: pointer;
    border: none;
  }

  .admin-loading-text{
    width: 100% !important;
    min-width: 100%;
    max-width: 100%;
    min-height: 62vh;
    max-height: 62vh;
    justify-content: center;
    text-align: center;
  }

  .admin-loading-text p{
    font-size: medium;
    margin-top: 10%;
  }

  .admin-loading-text .admin-request-spinner{
    font-size: medium;
    margin-top: 10%;
  }


  .rmsc {
    --rmsc-main: #EBEBEB !important;
    --rmsc-hover: #DEDED5 !important;
    --rmsc-selected: #EBEBEB !important;
    --rmsc-border: #f7f7f7 !important;
    --rmsc-gray: #000000 !important;
    --rmsc-bg: #EBEBEB !important;
    --rmsc-p: 0px 15px;
    --rmsc-radius: 4px !important;
  }

  .multi-select-custom{
    height: 50% !important;
    width: 80% !important;
    border-radius: 4px !important;
    font-weight: 100;
    font-size: small !important;
    color: #000000 !important;
    background-color: #EBEBEB !important;
    text-decoration: none !important;
  }

  .dropdown-heading{
    background-color: #EBEBEB !important;
    border-radius: 4px !important;
  }

  .dropdown-content{
    background-color: #EBEBEB !important;
    z-index: 1000 !important;
  }

  .dropdown-container{
    border: none !important;
    border-radius: 4px !important;
  }

  .sku-table-container{
    height: 50vh;
  }

  .sku-table-container .MuiTableContainer-root{
    height: auto !important;
    min-height: 60vh !important;
    max-height: 62vh !important;
  }

  .sku-table-container td {
    padding: 5px 15px !important;
  }
  
  .sort-button{
    padding-left: 3px;
    height: auto;
    width: 8px !important;
  }

  .sku-quarter-filter-single-select-dropdown {
    height: 53% !important;
    width: 85% !important;
    border-radius: 4px !important;
    font-weight: 100 !important;
    font-size: small !important;
    color: #000000 !important;
    text-decoration: none !important;
    background-color: #FFFFFF !important;
    border-radius: 4px !important;
    border: 1px solid #C4C4C4 !important;
  }

  .sku-exclusion-drop-down {
    cursor: pointer;
    padding: 0px 15px;
    border: none;
    height: 100%;
    width: 42%;
    border-radius: 4px;
    font-size: small;
    color: #000000;
    background-color: #EBEBEB;
    text-decoration: none;
  }

  .sku-quarter-selection-dropdown-container {
    font-size: large !important;
    height: 80% !important;
    width: 25% !important;
  }

  .single-select-dropdown {
    cursor: pointer;
    padding: 0px 15px;
    border: none;
    height: 100%;
    width: 100%;
    border-radius: 4px;
    font-size: medium;
    color: #000000;
    background-color: #EBEBEB;
    text-decoration: none;
    text-align: center;
  }

  .sku-stm-input-text-box {
    height: 53% !important;
    width: 85% !important;
    border-radius: 4px !important;
    font-weight: 100 !important;
    font-size: small !important;
    color: #000000 !important;
    text-decoration: none !important;
    background-color: #FFFFFF !important;
    border-radius: 4px !important;
    border: 1px solid #C4C4C4 !important;
  }

  .sku-stm-input-text-box:focus{
    outline: 0;
  }

  .sku-exclusion-list-column-container {
   height: 5vh; 
  }

  .sku-exclusion-list-comment-column {
    height: inherit !important;
    width: inherit;
    overflow: hidden;
    display: grid;
    align-items: center;
    justify-content: center;
   }

   .sku-exclusion-list-comment-column p {
    width: inherit !important;
    white-space: nowrap !important;
    word-wrap: break-word;
    word-break: break-word;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    margin: 0px;
   }

  .exclusion-apply-button-container{
    padding-left: 20px;
  }

  .exclusion-apply-button{
    background-color: #9B9595;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 80%;
    width: 30%;
  }

  .bold-font{
    font-weight: 800 !important;
  }

  .sku-legend-container{
    font-size: x-small;
    padding-bottom: 0px;
  }

  .sku-quarter-text{
    font-size: large;
    padding-top: 1vh;
  }

  .seach-box-container{
    margin-top: 28px !important;
  }

  .search-icon{
    color: #F7F7F7;
  }

  .search-button{
    background-color: #9B9595 !important;
    border: none !important;
  }

  .search-button:focus{
    outline: none;
    box-shadow:none !important;
  }
  
  .search-input-box{
    height: 38px !important;
    border-radius: 4px !important;
    color: #606060 !important;
    font-family: inherit !important;
    font-size: small !important;
    text-decoration: none !important;
    background-color: white !important;
    resize: none !important;
  }

  .search-input-box:focus{
    outline: none !important;
    box-shadow:none !important;
    border: 1px solid #ccc !important;
  }

  .sku-exclusion-cut-off-note-container {
    text-align: center;
    font-weight: 800;
    padding-bottom: 2px;
  }

  .sku-export-button-container{
    text-align: right;
  }

  .sku-text-area-input{
    width: 350px;
    border: 2px solid #EBEBEB !important;
  }

  .exclusion-apply-all-button{
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 80%;
    width: 26%;
    margin-left: 2%;
  }
  
  .sku-export-button {
    background-color: #E61C2A;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 80%;
    width: 26%;
    margin-left: 2%;
  }

  .sku-export-button:disabled {
    background-color: #9B9595;
  }

  .sku-delist-button{
    background-color: #E61C2A;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 50%;
    width: 25%;
  }

  .sku-delist-save-button{
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: medium;
    height: 80%;
    width: 50%;
    margin-left: 2%;
  }

  .sku-toggle-button{
    border-radius: 20px;
  }

  .sku-ban-popup-modal-form-body{
    height: 71.5vh !important;
    width: 100% !important;
    padding-top: 2vh;
  }

  .sku-ban-popup-modal-form-body .table-container th{
    color: black;
    font-size: small;
    text-overflow: ellipsis !important;
    font-weight: 800;
    text-align: center;
  }

  .toast-popup{
    background-color: #EBEBEB !important;
    font-family: 'Montserrat' !important;
    font-weight: 500 !important;
    justify-content: center !important;
    margin-top: 42vh !important;

  }

  .cutoff-popup{
    background-color: #EBEBEB !important;
    font-family: 'Montserrat' !important;
    font-weight: 500 !important;
    justify-content: center !important;
    margin-top: 42vh !important;
    width: 400px !important;
    min-width: 700px;
    max-width: 700px;
  }

  .brand-category-header-container{
    padding: 0px;
    margin: 0px 0px 10px 0px !important;
    width: 100%;
    height: 72px;
  }

  .brand-category-filter-container{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 72px;
    padding: 0px !important;
  }

  .brand-category-filter-container .rmsc{
    --rmsc-main: #EBEBEB !important;
    --rmsc-hover: #DEDED5 !important;
    --rmsc-selected: #EBEBEB !important;
    --rmsc-border: #C4C4C4 !important;
    --rmsc-gray: #000000 !important;
    --rmsc-bg: #EBEBEB !important;
    --rmsc-p: 0px 0px !important;
    --rmsc-radius: 4px !important;
  }

  .brand-category-dropdown-container{
    width: 246px;
    padding-right: 10px;
  }

  .water-category-dropdown-container{
    width: 180px;
    padding-right: 10px;
  }
  .ci-category-dropdown-container{
    width: 170px;
    padding-right: 10px;
  }

  .brand-category-dropdown-container .dropdown-heading,
  .water-category-dropdown-container .dropdown-heading,
  .ci-category-dropdown-container .dropdown-heading{
    background-color: #FFFFFF !important;
    border-radius: 4px !important;
    border: 1px solid #C4C4C4 !important;
  }

  .brand-category-multi-select-custom {
    height: 50% !important;
    width: 85% !important;
    border-radius: 4px !important;
    font-weight: 100;
    font-size: small !important;
    color: #000000 !important;
    text-decoration: none !important;
  }

  .brand-category-multi-select-custom .dropdown-heading-value{
    padding-left: 1vh;
  }

  .brand-category-add-delete-export-button-container{
    padding: 0px !important;
    display: flex;
    align-items: center;
  }

  .brand-category-button{
    background-color: #E61C2A;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 50%;
    width: 25%;
    margin-right: 5px;
  }

  .brand-category-export-button{
    background-color: #9B9595;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 50%;
    width: 25%;
    margin-right: 5px;
  }

  .brand-category-body{
    margin-top: 20px;
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
  }

  .table-holder{
    height: 77.5vh;
  }

  .other-mfa-table-holder{
    height: 71.5vh;
  }

  .brand-category-chips-container{
    height: 53px;
    margin: 0px 10px;
  }
  
  .channel-category-chips-container{
    height: 20px;
    margin: 0px 10px;
  }

  .brand-category-chips-container .mdc-ripple-upgraded{
    z-index: 0 !important;
  }

  .brand-category-table-container{
    height: calc(74vh - 8vh);
    margin: 0px 10px;
  }

  .brand-category-table-container .MuiTableContainer-root {
    height: auto !important;
    min-height: calc(74vh - 8vh) !important;
    max-height: 62vh !important;
  }

  .brand-category-table-container .MuiCheckbox-root {
    z-index: 0;
  }

  .brand-category-table-container th {
    text-align: center !important;
    z-index: 0;
  }

  .brand-category-table-container td {
    text-align: center !important;
  }

  .brand-category-table-container .MuiTableRow-root{
    height: 10px !important;
    border-left: 0px solid !important;
  }

  .brand-category-table-container .MuiTableHead-root{
    height: 60px !important;
  }

  .mdc-chip{
    padding: 0px 20px !important;
    background-color: #FFFFFF!important;
    color: #7F7F7F !important;
    border: 1px solid #C4C4C4 !important;
    border-radius: 40px !important;
  } 
  
  .mdc-chip--selected{
    background-color: #7F7F7F !important;
    color: #FFFFFF!important;
  }

  .brand-category-modal-form-header{
    height: 6vh !important;
    width: 100% !important;
    border-bottom: 1px solid #C3C3C3 !important;
    display: flex;
    flex-direction: row;
  }

  .brand-category-modal-form-header p {
    padding: 1vh 0vh 0vh 1vh;
    font-size: 2rem;
    font-weight: 550;
    margin: 0px;
  }

  .brand-category-modal-form-close-button{
    margin: 1vh 1vh 0vh auto;
    cursor: pointer
  }

  .brand-category-modal-form-body{
    height: 71.5vh !important;
    width: 100% !important;
    padding-top: 2vh;
  }

  .brand-category-modal-form-footer{
    height: 10vh;
    width: 100% !important;
    border-top: 1px solid #C3C3C3;
    padding-top: 2vh;
  }

  .brand-category-modal-form-input-container{
    height: 11.5vh !important;
    width: 100% !important;
    padding: 0.5vh 1vw 0vh 1vw;
  }

  .brand-category-modal-form-input-separator{
    height: 4vh !important;
    width: 100% !important;
    padding: 0vh 1vw;
    display: flex;
  }

  .brand-category-modal-form-input{
    width: 15vw;
  }
  .brand-category-modal-form-input2{
    width: 15vw;
  }
  .brand-category-modal-form-input p {
    margin: 0px 0px 0px 1vh;
    font-size: 1rem;
    font-style: normal;
    color: #7F7F7F;
    font-weight: 600;
  }

  .brand-category-modal-form-note{
    text-align: center;
    background-color: #F2F2F2;
    color: #000000 !important;
    margin-top: 5.5vh !important;
    word-spacing: 0.2vw;
    margin-left: 37% !important;
    margin-right: -41% !important;
  }

  .brand-category-text-input-box{
    height: 5.3vh;
    border: none;
    width: 13.8vw;
    font-size: 16px;
    text-decoration: none;
    text-overflow: ellipsis;
    resize: none;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 1rem;
  }

  .brand-category-text-input-box:focus{
    outline: 0;
  }

  .brand-category-text-suggest-input-box-container .wrapper {
    z-index: auto !important;
  }

  .brand-category-text-suggest-input-box-container .sc-gsDKAQ {
    z-index: 1!important;
    background-color: #ffffff;
    max-height: 15vh;
    overflow: hidden;
    overflow-y: scroll;
  }


  .brand-category-text-suggest-input-box-container .wrapper {
    width: 13.8vw !important;
  }

  .brand-category-modal-form-input-separator-title{
    margin: auto 0px;
    align-items: center;
    width: 20vw;
    font-weight: 600;
    padding-right: 1vw;
  }

  .brand-category-modal-form-input-separator-title p{
    margin: 0px !important;
    font-size: 2.5vh
  }

  .brand-category-modal-form-input-separator-line{
    margin: auto 0px;
    align-items: center;
    width: 100%;
    color: #7F7F7F;
  }

  .brand-category-form-modal-cancel-button{
    margin: auto 2vh auto 2vh;
    background-color: #F2F2F2;
    border: none;
    border-radius: 20px;
    color: #7F7F7F;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 5vh;
    width: 10vw;
  }

  .brand-category-form-modal-submit-button{
    margin: auto 2vh auto 2vh;
    background-color: #E61C2A;
    border: none;
    border-radius: 20px;
    color: #F7F7F7;
    text-align: center;
    text-decoration: none;
    font-size: small;
    height: 5vh;
    width: 10vw;
  }

  .brand-category-dialogue-icon-container{
    justify-content: center;
    text-align: center;
    width: 42px;
    border-radius: 500px;
    height: 42px;
    margin: auto;
  }

  .brand-category-dialogue-icon{
    color: #9B9595;
    height: 6vh;
  }

  .brand-category-dialogue-box-header{
    font-weight: 600 !important;
    color: #E61C2A;
    text-align: center;
    padding-top: 2vh;
    
  }

  .brand-category-dialogue-box-description{
    text-align: center;
    width: 15vw;
    margin: auto;
  }

  .brand-category-dialogue-box-input-box-container{
    text-align: center;
    margin: auto;
  }

  .brand-category-dialogue-box-input-box{
    height: 10vh;
    width: 20vw;
    border-radius: 4px;
    color: #606060;
    font-family: inherit;
    font-size: small;
    text-decoration: none;
    text-overflow: ellipsis;
    resize: none;
  }

  .brand-category-dialogue-box-input-box:focus{
    outline: 0;
  }

  .brand-category-dialogue-button-container{
    justify-content: center !important;
    text-align: center;
    padding-top: 1vh;
  }

  .brand-category-dialogue-button-submit{
    background: #E61C2A !important;
    border-radius: 35px !important;
    height: 5vh !important;
    width: 10vw !important;
    color: white !important;
    font-size: small !important;
  }

  .brand-category-dialogue-button-cancel{
    background: #9B9595 !important;
    border-radius: 35px !important;
    height: 5vh !important;
    width: 15vw !important;
    color: white !important;
    font-size: small !important;
  }
  
.ch-ft{
  width: 60.333333% !important;
}
.ch-act{
  width: 38% !important;
  margin-top: 12px !important;
  margin-bottom: -5px;
  margin-left: -103px; 
}

.ch-btn{
 width: 18%;
  float: right;
  margin-right: -25px;
  margin-left: 32px;
}

.ch-dp-dn{
  height: 35px !important;
}

.ch-table{
  margin: 0px 0px;
  padding-top: 20px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

button.ch-btn.brand-category-button.mt-3.col span.hover-button{
  position: fixed;
  width: 150px;
  background: #5e5b5b;
  padding: 15px 10px 0px 10px;
  box-sizing: border-box;
  border-radius: 5px;
  visibility: hidden;
  opacity: 0;
  transform: translateX(-50px) translateY(-50px);
}
button.ch-btn.brand-category-button.mt-3.col span.hover-button::before{
  content: '';
  position: fixed;
  width: 15px;
  height: 15px;
  background:#5e5b5b ;
  top: -5px;
  transform: rotate(45deg);
}
button.ch-btn.brand-category-button.mt-3.col:hover span.hover-button{
  visibility: visible;
  opacity: 1;
  margin-left: -65px;
  margin-top: 31px;
  transform: translateX(-50px) translateY(0px);
  z-index: 1;
}


button.tb-btn.ch-btn.brand-category-button.mt-3.col {
  margin-right: 82%;
  margin-left: 5px;
  width: 80px;
  margin-top: 1px !important;
  height: 35px !important;
  margin-bottom: -1%;
}

.sv-btn {
  display:inline-flex;width:45%;
}
.ch-hm{
  margin-top: 45px;
}

.rf-inp{
  margin-right: 35px;
  width: 45% !important;
}
.lf-rnp{
  margin-left: 35px;
  width: 45% !important;
}

.brand-category-modal-form-input.col-3.p-0.check-bx {
  margin-top: -40px !important;
  margin-bottom: 50px;
  margin-left: 10px;
}

.imp-fl{
  position: absolute;
  font-size: 13px;
  margin: 56px 26vw;
  width: 200px;
  height: 31px;
  text-align: center;
  border-radius: 12px;
  padding-top: 5px;
}
.tb-ch{
  margin-left: -3.8rem;
    margin-top: 0.4rem;
    max-width: 120% !important;
    width: 110% !important;
}
.ant-table-thead{
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-size: 12px;
}
.ant-table-tbody{
  font-size: 12px;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 400;
  color: rgb(0 0 0) !important; 
};

.ant-table-cell{
  font-family: "Roboto","Helvetica","Arial",sans-serif !important;
}

  .ant-table-content{
  zoom:0.89
}
.ant-table-filter-dropdown {
  margin-top: -20px !important; 
} 
.ant-select-selection-item{
  font-size: 11px !important;
}
.ant-select-selection-item-remove{
  font-size: 6px !important;
}
.class-in-td{
  font-weight: bold;
}
.ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child{
background-color: #ffccc7;

}

.editable-cell {
  position: relative;
}

.editable-cell-value-wrap {
  padding: 5px 12px;
  cursor: pointer;
}

.editable-row:hover .editable-cell-value-wrap {
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}
.ym-zw {
  display:inline-flex;width:45%;
}
.bt-pc {
  width: 89px;
  height: 35px;
  color: white;
  }


.tb-ch .ant-table-wrapper .ant-table-container table>thead>tr:first-child >* {
  background-color: #424242;
  color:white
}

.tb-ch .ant-table-wrapper .ant-table-container table>thead>tr:first-child >* .anticon {
  color:white
}
.sc-btn.ch-act.col-2.brand-category-add-delete-export-button-container {
  margin-left: 96%;
  margin-top: -61px !important;
  margin-bottom: 9px;
  height: 93%;
  display: block;
  width: 5% !important;
}

.cst-hr{
  width: 165px !important;
}

.fx-sv{
  margin-top: -25px !important;
  margin-left: 60px !important;
}

.hier.cst-hr.brand-category-dropdown-container {
  width: 200px !important;
}

tbody>tr>td.ant-table-cell.country-column {
  background-color: #E2E2E2;
}

.levels-img {
  height: 25%;
  width: 22%;
  margin: 0px 0px 0px 40px;
}
.MuiTableCell-root .MuiTableCell-body .tableCellYouth .MuiTableCell-sizeSmall{
  margin: 0px !important;
  padding: 0px !important;
}

.pf-export-button{
  background-color: #E61C2A;
  border: none;
  border-radius: 25px;
  color: #F7F7F7;
  text-align: center;
  text-decoration: none;
  font-size: small;
  height: 80%;
  width: 80%;
  margin: 20px;
}



.brand-category-table-container-new .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child{
  background-color: #fff;
  }

.brand-category-table-container-new .dropdown-heading,
.water-category-dropdown-container .dropdown-heading,
.ci-category-dropdown-container .dropdown-heading{
  background-color: #FFFFFF !important;
  border-radius: 4px !important;
  border: 1px solid #C4C4C4 !important;
}

.brand-category-multi-select-custom-new{
  height: 50% !important;
  width: 85% !important;
  border-radius: 4px !important;
  font-weight: 100;
  font-size: small !important;
  color: #000000 !important;
  text-decoration: none !important;
}

.brand-category-multi-select-custom-new .dropdown-heading-value{
  padding-left: 1vh;
}

.brand-category-add-delete-export-button-container{
  padding: 0px !important;
}



.brand-category-export-button-w{
  background-color: #9B9595;
  border: none;
  border-radius: 20px;
  color: #F7F7F7;
  text-align: center;
  text-decoration: none;
  font-size: small;
  height: 60%;
  width: 30%;
  float: right;
  margin-right: 35px;
}

.brand-category-body{
  margin-top: 20px;
  height: 100%;
  width: 100%;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.brand-category-table-container-new .ant-table-row .ant-table-cell {
  font-size: 17px;
  font-weight: 100 !important;
  padding: 10px !important;
  font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';
  text-overflow: ellipsis !important;
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  
}
.brand-category-table-container-new .ant-table-thead >tr>th{
  font-size: 15px !important;

}

.m-qrtr{
  margin-top: 8px !important;
  margin-left: 0px !important;
  width: 179px;
}

.brand-background {
  background-color: #e61c2a !important;
}

.ant-table-body {
  overflow-y: auto !important;
}

#webpack-dev-server-client-overlay {
  display: none !important;
  pointer-events: none !important;
}

#webpack-dev-server-client-overlay-div {
  display: none !important;
  pointer-events: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ;;EAEA;IACE,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,yCAAyC;EAC3C;EACA;IACE,SAAS;IACT,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,SAAS;IACT,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,cAAc;;EAEhB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,oDAAoD;IACpD,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,oDAAoD;IACpD,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,uBAAuB;IACvB,oDAAoD;IACpD,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;KACX,iBAAiB;IAClB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;IACV,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;AACF;EACE,iBAAiB;AACnB;EACE;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,2BAA2B;;EAE7B;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;EACpC;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kCAAkC;IAClC,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,UAAU;IACV,WAAW;CACd;;EAEC;IACE,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;;EAGA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;IAC/B,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;IACpC,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;IAChC,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,UAAU;EACZ;;EAEA;GACC,WAAW;EACZ;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;GACxB;;GAEA;IACC,yBAAyB;IACzB,8BAA8B;IAC9B,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;IAC3B,kCAAkC;IAClC,WAAW;GACZ;;EAED;IACE,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,gCAAgC;IAChC,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;IACxB,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;IACX,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;;EAE7B;;EAEA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;IAC3B,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,mCAAmC;IACnC,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;IACjC,+BAA+B;IAC/B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;;IAGE,oCAAoC;IACpC,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uCAAuC;IACvC,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,mCAAmC;IACnC,yBAAyB;IACzB,oCAAoC;IACpC,8BAA8B;EAChC;;EAEA;IACE,oCAAoC;IACpC,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB;EACF;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB;EACF;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,gBAAgB;;EAElB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,8BAA8B;IAC9B,8BAA8B;IAC9B,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;EAC7B;;AAEF;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;CACC,UAAU;EACT,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;AACZ;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,CAAC,SAAS;AAC/B;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,sBAAsB;AAC1B;AACA;EACE,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,eAAe;EACf,oDAAoD;EACpD,gBAAgB;EAChB,4BAA4B;AAC9B,CAAA;;AAEA;EACE,+DAA+D;AACjE;;EAEE;EACA;AACF;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;AACA,yBAAyB;;AAEzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mBAAmB,CAAC,SAAS;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ;;;AAGF;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;;;AAIA;EACE,sBAAsB;EACtB;;AAEF;;;EAGE,oCAAoC;EACpC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,wBAAwB;EACxB,uLAAuL;EACvL,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;;AAEpB;AACA;EACE,0BAA0B;;AAE5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Montserrat');\n \n.App {\n  text-align: center;\n}\n\n.sign-in-button-container {\n  display: flex;\n  min-height: 100vh;\n  height: 100vh;\n  align-items: center;\n  justify-content: center;\n}\n\n.login-page2 {\n  position:absolute;\n  top:50%;\n  left:50%;\n  margin-top:-50px;\n  margin-left:-100px;\n  height: 30vh;\n  width: 50vh;\n  border: #282c34 1px solid;\n  background-color: #F7F7F7;\n}\n\n.login-page {\n  height: 100vh;\n  width: 100%;\n  background-color: #F7F7F7;\n}\n\n.cch_logo_login {\n  top: 40px;\n  left: 25px;\n  width: 180px;\n  height: auto;\n  position: fixed;\n}\n\n.edge_logo_login {\n  top: 40px;\n  right: 40px;\n  width: 180px;\n  height: auto;\n  position: fixed;\n}\n\n.login-box{\n  width: 350px;\n  height: 260px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #F7F7F7;\n  border-radius: 8px;\n  box-shadow: 5px 5px 17px #ccc;\n}\n\n.login-box-header{\n  height: 35%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.login-page-logo{\n  height: 38%;\n  width: 38%;\n  margin: 5% 0% 0% 5%;\n}\n\n.login-box-body{\n  height: 65%;\n}\n\n.login-box-body label{\n  font-weight: 600;\n  font-size: large;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.sidebar p{\n  font-family: 'Montserrat';\n  font-size: medium;\n  font-weight: 600;\n}\n\n.sidebar:hover{\n  background-color: #EBEBEB;\n  color:#606060;\n  font-weight: 700;\n  font-size: 28;\n  text-decoration: none !important;\n}\n\n.navLinks:hover{\n  background-color: #EBEBEB;\n  color:#606060; \n  text-decoration: none;\n  text-emphasis: none;\n}\n\n.navLinks{\n  text-decoration: none;\n}\n\n.box-container{\n  height: 82px;\n  }\n  \n  .box-container .css-ciy9n4-MuiPaper-root-MuiAppBar-root{\n    box-shadow: none !important;\n    border-bottom: 3px solid #EBEBEB;\n  }\n  \n  .body-container{\n    top: 20px;\n    height: auto !important; \n    min-height: calc(100vh - 82px) !important;\n  }\n  .body-container-sustain{\n    top: 20px;\n    height: auto !important; \n    min-height: calc(100vh + 10px) !important;\n  }\n\n  .loading-home-container{\n    top: 20px;\n    height: 100% !important; \n    min-height: calc(100vh - 82px) !important;\n  }\n  \n  .navbar-company-icon{\n    width: 8.5rem;\n    padding: 0px 2px;\n  }\n  \n  .navbar-company-icon img{\n    width: 100%;\n  }\n  \n  .navlink-container{\n    width: 100%;\n    padding-left: 65px;\n    display: flex;\n    max-width: 80%;\n    overflow-x: auto;\n    align-items: center;\n  }\n  \n  .navLinks{\n    color: #606060;\n    padding: 10px 42px;\n    /* font-size: 20;  */\n    text-decoration: none;\n    margin: 0px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .navLinks p{\n    margin: 0px;\n    padding-top: 5px;\n    font-family: 'Montserrat';\n    font-size: small;\n    font-weight: 600;\n    text-align: center;\n  }\n  \n  .navLinks img{\n    width: 38px;\n  }\n  \n  .navlink-active{\n    border-bottom: 3px solid #E61C2A;\n  }\n\n  .navlink-icon{\n    color: #9B9595;\n  }\n\n  .navlink-active .navlink-icon{\n    color: #E61C2A;\n  }\n\n  .navlink-active .navlink-text{\n    color: #E61C2A;\n  }\n  \n  .landing-header{\n    background-color: #F7F7F7 !important;\n    color: #606060 !important;\n  }\n  \n  .navbar-logout-container{\n    /* position: absolute; */\n    right: 24px;\n    display: flex;\n  }\n\n  .navbar-right-section-icon{\n    padding: 10px 20px;\n    color: #E61C2A;\n    cursor: pointer;\n  }\n\n  .sidebar-color{\n    background-color: #F7F7F7;\n  }\n\n  .sidebar-divider{\n    background-color: #EBEBEB;\n  }\n\n  .css-1f2xuhi-MuiDrawer-docked .MuiDrawer-paper{\n    background-color: #F7F7F7;\n  }\n\n  .css-3v9zut{\n    height: 82px;\n  }\n  .sidebar-header-title{\n    margin: 0px;\n    margin-right: auto;\n    color: #606060;\n    font-family: 'Montserrat';\n    font-size: larger;\n    font-weight: 600;\n  }\n\n  .body-container,.body-container-sustain{\n    background-color: #F7F7F7;\n    color: #606060;\n    font-family: 'Montserrat';\n    font-size: larger;\n    font-weight: 600;\n    padding: 15px 15px;\n    width: 100%;\n  }\n\n  .user-view-container{\n    height: 100%;\n    padding: 0% 2%;\n  \n  }\n  \n  .user-view-header{\n    height: 10vh;\n    padding: 0%;\n    margin: 0%;\n  }\n\n  .user-view-input-layer{\n    height: 10vh;\n    padding: 0%;\n    margin: 0%;\n  }\n\n  .user-view-input-layer .navlink-icon {\n    color: #E61C2A;\n    cursor: pointer;\n  }\n  \n  .country-drop-down {\n    cursor: pointer;\n    padding: 0px 15px;\n    border: none;\n    height: 50%;\n    width: 80%;\n    border-radius: 4px;\n    font-size: small;\n    color: #000000;\n    background-color: #EBEBEB;\n    text-decoration: none;\n  }\n\n  select {\n    outline: 0;\n    box-shadow: none;\n    text-overflow: ellipsis;\n  }\n  \n  select:focus{\n    outline: 0;\n    box-shadow: none;\n  }\n  \n  .country-drop-down:hover{\n    background-color: #f0efef;\n    border-radius: 4px;\n  }\n  \n  .select-dropdown-option{\n    background-color: #EBEBEB;\n    text-overflow: ellipsis;\n  }\n\n  .user-view-text-header{\n    font-size: small;\n    font-weight: 800;\n    text-overflow: ellipsis;\n  }\n\n  .user-view-text-value{\n    font-size: small;\n    font-weight: 200;\n    padding-left: 10px;\n  }\n\n  .text-input-box {\n    padding: 8px;\n    height: 40px;\n    border: none;\n    width: 98%;\n    border-radius: 4px;\n    color: #606060;\n    font-family: inherit;\n    font-size: small;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    background-color: white;\n    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);\n    resize: none;\n  }\n\n  .text-input-box:focus {\n    outline: 0;\n  }\n\n  .text-input-box-disabled {\n    padding: 8px;\n    height: 40px;\n    border: none;\n    width: 98%;\n    border-radius: 4px;\n    color: #606060;\n    font-family: inherit;\n    font-size: small;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    background-color: #F2F2F2;\n    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);\n    resize: none;\n  }\n\n  .text-input-textarea{\n    height: 60px;\n    border: none;\n    width: 98%;\n    border-radius: 4px;\n    color: #606060;\n    font-family: inherit;\n    font-size: small;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    background-color: white;\n    box-shadow: 0.2em 0.2em 0.6em 0.05em rgba(0,0,0,0.2);\n    resize: none;\n  }\n\n  .text-input-textarea:focus{\n    outline: 0;\n  }\n\n  .user-view-input-label-text{\n    font-size: small;\n    font-weight: 580;\n    color: black;\n     margin-top: 1.5vh; \n    padding-right: 15px;\n    text-overflow: ellipsis;\n  }\n\n  .user-view-input-label-text-comment{\n    font-size: small;\n    font-weight: 580;\n    color: black;\n    margin-top: 1.5vh;\n    padding-right: 11px;\n    text-overflow: ellipsis;\n  }\n\n  .user-view-kbi-unit{\n    font-size: small;\n    color: black;\n    text-overflow: ellipsis;\n    font-weight: 580;\n    margin-top: 1.5vh;\n    padding-left: 15px;\n  }\n  \n  .user-view-input-layer-comment{\n    height: 15vh;\n    padding: 0%;\n    margin: 0%;\n    text-overflow: ellipsis;\n  }\n\n  .user-view-added-at-container{\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .user-view-added-by-container{\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .form-submit-button{\n    background-color: #E61C2A;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 60%;\n    width: 10%;\n    float: right;\n    margin-right: 35px;\n  }\n\n  .export-button{\n    background-color: #9B9595;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 60%;\n    width: 30%;\n    float: right;\n    margin-right: 35px;\n  }\n\n  .user-view-input-layer-submit{\n    height: 10vh;\n    width: 100%;\n  }\n\n  .edit-button-container{\n    text-align: end;\n  }\n\n  .dialogue-box-container .MuiDialog-paper{\n    min-height: 33vh;\n    max-width: 33vh;\n    min-width: 38vh;\n  }\n\n  .MuiDialog-paperWidthSm {\n    max-width: none !important;\n  }\n  \n  .dialogue-button-container{\n    justify-content: center !important;\n    padding: 16px 24px !important;\n  }\n\n  .dialogue-button-submit{\n    background: #E61C2A !important;\n    border-radius: 35px !important;\n    height: 5vh !important;\n    width: 20vh !important;\n    color: white !important;\n    font-size: small !important;\n    border: none !important;\n  }\n\n  .dialogue-button-cancel{\n    background: #9B9595 !important;\n    border-radius: 35px !important;\n    width: 20vh !important;\n    color: white !important;\n    font-size: x-small !important;\n  }\n.channel-category-modal{\n  align-items: flex;\n}\n  .dialogue-icon-container{\n    justify-content: center;\n    text-align: center;\n    width: 42px;\n    border: 1px #9B9595 solid;\n    border-radius: 500px;\n    height: 42px;\n    margin: auto;\n  }\n\n  .dialogue-icon{\n    color: #9B9595;\n    height: 6vh;\n  }\n\n  .dialogue-box-header{\n    font-weight: 600 !important;\n    \n  }\n   \n  .table-container {\n    width: 100% !important;\n    min-width: 100%;\n    max-width: 100%;\n    min-height: 62vh;\n    overflow: auto;\n    overflow-x: auto;\n    margin: 0px !important;\n    border-radius: 10px;\n    background-color: white;\n    box-shadow: 4px 3px 8px 1px #969696;\n    text-overflow: ellipsis;\n  }\n  \n  .table-container th{\n    color: #E61C2A;\n    font-size: small;\n    text-overflow: ellipsis !important;\n    text-align: center;\n  }\n\n  .table-container tr{\n    font-size: small;\n    font-weight: 200;\n    text-overflow: ellipsis !important;\n  }\n\n  .table-container td{\n    font-size: small;\n    font-weight: 200;\n    max-width: 20vh;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    text-align: center;\n    padding-top: 1rem !important;\n  }\n\n  tbody{\n    font-size: small;\n    font-weight: 200;\n    text-overflow: ellipsis !important;\n    border-top: 1px solid #9B9595;\n    overflow-y: scroll;\n  }\n\n  .table>:not(:first-child){\n    border-top: 0px solid #9B9595;\n  }\n\n  .table-data-note{\n    width: 100%;\n    justify-content: center;\n    text-align: center;\n    font-size: medium;\n    margin-top: 20vh;\n  }\n\n  .admin-button-container{\n    float: right;\n    margin-top: 5vh;\n    width: 30%;\n    height: 6vh;\n }\n\n  .admin-button-reject{\n    border-radius: 60px;\n    width: 30%;\n    height: 100%;\n    background-color: #9B9595;\n    color: #F7F7F7;\n    font-size: small;\n    cursor: pointer;\n    border: 1px solid #E61C2A;\n  }\n\n  .admin-button-approve{\n    border-radius: 60px;\n    width: 30%;\n    height: 100%;\n    background-color: #E61C2A;\n    color: #F7F7F7;\n    font-size: small;\n    cursor: pointer;\n    border: none;\n  }\n\n  .admin-loading-text{\n    width: 100% !important;\n    min-width: 100%;\n    max-width: 100%;\n    min-height: 62vh;\n    max-height: 62vh;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .admin-loading-text p{\n    font-size: medium;\n    margin-top: 10%;\n  }\n\n  .admin-loading-text .admin-request-spinner{\n    font-size: medium;\n    margin-top: 10%;\n  }\n\n\n  .rmsc {\n    --rmsc-main: #EBEBEB !important;\n    --rmsc-hover: #DEDED5 !important;\n    --rmsc-selected: #EBEBEB !important;\n    --rmsc-border: #f7f7f7 !important;\n    --rmsc-gray: #000000 !important;\n    --rmsc-bg: #EBEBEB !important;\n    --rmsc-p: 0px 15px;\n    --rmsc-radius: 4px !important;\n  }\n\n  .multi-select-custom{\n    height: 50% !important;\n    width: 80% !important;\n    border-radius: 4px !important;\n    font-weight: 100;\n    font-size: small !important;\n    color: #000000 !important;\n    background-color: #EBEBEB !important;\n    text-decoration: none !important;\n  }\n\n  .dropdown-heading{\n    background-color: #EBEBEB !important;\n    border-radius: 4px !important;\n  }\n\n  .dropdown-content{\n    background-color: #EBEBEB !important;\n    z-index: 1000 !important;\n  }\n\n  .dropdown-container{\n    border: none !important;\n    border-radius: 4px !important;\n  }\n\n  .sku-table-container{\n    height: 50vh;\n  }\n\n  .sku-table-container .MuiTableContainer-root{\n    height: auto !important;\n    min-height: 60vh !important;\n    max-height: 62vh !important;\n  }\n\n  .sku-table-container td {\n    padding: 5px 15px !important;\n  }\n  \n  .sort-button{\n    padding-left: 3px;\n    height: auto;\n    width: 8px !important;\n  }\n\n  .sku-quarter-filter-single-select-dropdown {\n    height: 53% !important;\n    width: 85% !important;\n    border-radius: 4px !important;\n    font-weight: 100 !important;\n    font-size: small !important;\n    color: #000000 !important;\n    text-decoration: none !important;\n    background-color: #FFFFFF !important;\n    border-radius: 4px !important;\n    border: 1px solid #C4C4C4 !important;\n  }\n\n  .sku-exclusion-drop-down {\n    cursor: pointer;\n    padding: 0px 15px;\n    border: none;\n    height: 100%;\n    width: 42%;\n    border-radius: 4px;\n    font-size: small;\n    color: #000000;\n    background-color: #EBEBEB;\n    text-decoration: none;\n  }\n\n  .sku-quarter-selection-dropdown-container {\n    font-size: large !important;\n    height: 80% !important;\n    width: 25% !important;\n  }\n\n  .single-select-dropdown {\n    cursor: pointer;\n    padding: 0px 15px;\n    border: none;\n    height: 100%;\n    width: 100%;\n    border-radius: 4px;\n    font-size: medium;\n    color: #000000;\n    background-color: #EBEBEB;\n    text-decoration: none;\n    text-align: center;\n  }\n\n  .sku-stm-input-text-box {\n    height: 53% !important;\n    width: 85% !important;\n    border-radius: 4px !important;\n    font-weight: 100 !important;\n    font-size: small !important;\n    color: #000000 !important;\n    text-decoration: none !important;\n    background-color: #FFFFFF !important;\n    border-radius: 4px !important;\n    border: 1px solid #C4C4C4 !important;\n  }\n\n  .sku-stm-input-text-box:focus{\n    outline: 0;\n  }\n\n  .sku-exclusion-list-column-container {\n   height: 5vh; \n  }\n\n  .sku-exclusion-list-comment-column {\n    height: inherit !important;\n    width: inherit;\n    overflow: hidden;\n    display: grid;\n    align-items: center;\n    justify-content: center;\n   }\n\n   .sku-exclusion-list-comment-column p {\n    width: inherit !important;\n    white-space: nowrap !important;\n    word-wrap: break-word;\n    word-break: break-word;\n    overflow: hidden !important;\n    text-overflow: ellipsis !important;\n    margin: 0px;\n   }\n\n  .exclusion-apply-button-container{\n    padding-left: 20px;\n  }\n\n  .exclusion-apply-button{\n    background-color: #9B9595;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 80%;\n    width: 30%;\n  }\n\n  .bold-font{\n    font-weight: 800 !important;\n  }\n\n  .sku-legend-container{\n    font-size: x-small;\n    padding-bottom: 0px;\n  }\n\n  .sku-quarter-text{\n    font-size: large;\n    padding-top: 1vh;\n  }\n\n  .seach-box-container{\n    margin-top: 28px !important;\n  }\n\n  .search-icon{\n    color: #F7F7F7;\n  }\n\n  .search-button{\n    background-color: #9B9595 !important;\n    border: none !important;\n  }\n\n  .search-button:focus{\n    outline: none;\n    box-shadow:none !important;\n  }\n  \n  .search-input-box{\n    height: 38px !important;\n    border-radius: 4px !important;\n    color: #606060 !important;\n    font-family: inherit !important;\n    font-size: small !important;\n    text-decoration: none !important;\n    background-color: white !important;\n    resize: none !important;\n  }\n\n  .search-input-box:focus{\n    outline: none !important;\n    box-shadow:none !important;\n    border: 1px solid #ccc !important;\n  }\n\n  .sku-exclusion-cut-off-note-container {\n    text-align: center;\n    font-weight: 800;\n    padding-bottom: 2px;\n  }\n\n  .sku-export-button-container{\n    text-align: right;\n  }\n\n  .sku-text-area-input{\n    width: 350px;\n    border: 2px solid #EBEBEB !important;\n  }\n\n  .exclusion-apply-all-button{\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 80%;\n    width: 26%;\n    margin-left: 2%;\n  }\n  \n  .sku-export-button {\n    background-color: #E61C2A;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 80%;\n    width: 26%;\n    margin-left: 2%;\n  }\n\n  .sku-export-button:disabled {\n    background-color: #9B9595;\n  }\n\n  .sku-delist-button{\n    background-color: #E61C2A;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 50%;\n    width: 25%;\n  }\n\n  .sku-delist-save-button{\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: medium;\n    height: 80%;\n    width: 50%;\n    margin-left: 2%;\n  }\n\n  .sku-toggle-button{\n    border-radius: 20px;\n  }\n\n  .sku-ban-popup-modal-form-body{\n    height: 71.5vh !important;\n    width: 100% !important;\n    padding-top: 2vh;\n  }\n\n  .sku-ban-popup-modal-form-body .table-container th{\n    color: black;\n    font-size: small;\n    text-overflow: ellipsis !important;\n    font-weight: 800;\n    text-align: center;\n  }\n\n  .toast-popup{\n    background-color: #EBEBEB !important;\n    font-family: 'Montserrat' !important;\n    font-weight: 500 !important;\n    justify-content: center !important;\n    margin-top: 42vh !important;\n\n  }\n\n  .cutoff-popup{\n    background-color: #EBEBEB !important;\n    font-family: 'Montserrat' !important;\n    font-weight: 500 !important;\n    justify-content: center !important;\n    margin-top: 42vh !important;\n    width: 400px !important;\n    min-width: 700px;\n    max-width: 700px;\n  }\n\n  .brand-category-header-container{\n    padding: 0px;\n    margin: 0px 0px 10px 0px !important;\n    width: 100%;\n    height: 72px;\n  }\n\n  .brand-category-filter-container{\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    height: 72px;\n    padding: 0px !important;\n  }\n\n  .brand-category-filter-container .rmsc{\n    --rmsc-main: #EBEBEB !important;\n    --rmsc-hover: #DEDED5 !important;\n    --rmsc-selected: #EBEBEB !important;\n    --rmsc-border: #C4C4C4 !important;\n    --rmsc-gray: #000000 !important;\n    --rmsc-bg: #EBEBEB !important;\n    --rmsc-p: 0px 0px !important;\n    --rmsc-radius: 4px !important;\n  }\n\n  .brand-category-dropdown-container{\n    width: 246px;\n    padding-right: 10px;\n  }\n\n  .water-category-dropdown-container{\n    width: 180px;\n    padding-right: 10px;\n  }\n  .ci-category-dropdown-container{\n    width: 170px;\n    padding-right: 10px;\n  }\n\n  .brand-category-dropdown-container .dropdown-heading,\n  .water-category-dropdown-container .dropdown-heading,\n  .ci-category-dropdown-container .dropdown-heading{\n    background-color: #FFFFFF !important;\n    border-radius: 4px !important;\n    border: 1px solid #C4C4C4 !important;\n  }\n\n  .brand-category-multi-select-custom {\n    height: 50% !important;\n    width: 85% !important;\n    border-radius: 4px !important;\n    font-weight: 100;\n    font-size: small !important;\n    color: #000000 !important;\n    text-decoration: none !important;\n  }\n\n  .brand-category-multi-select-custom .dropdown-heading-value{\n    padding-left: 1vh;\n  }\n\n  .brand-category-add-delete-export-button-container{\n    padding: 0px !important;\n    display: flex;\n    align-items: center;\n  }\n\n  .brand-category-button{\n    background-color: #E61C2A;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 50%;\n    width: 25%;\n    margin-right: 5px;\n  }\n\n  .brand-category-export-button{\n    background-color: #9B9595;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 50%;\n    width: 25%;\n    margin-right: 5px;\n  }\n\n  .brand-category-body{\n    margin-top: 20px;\n    height: 100%;\n    width: 100%;\n    background-color: #FFFFFF;\n    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n  }\n\n  .table-holder{\n    height: 77.5vh;\n  }\n\n  .other-mfa-table-holder{\n    height: 71.5vh;\n  }\n\n  .brand-category-chips-container{\n    height: 53px;\n    margin: 0px 10px;\n  }\n  \n  .channel-category-chips-container{\n    height: 20px;\n    margin: 0px 10px;\n  }\n\n  .brand-category-chips-container .mdc-ripple-upgraded{\n    z-index: 0 !important;\n  }\n\n  .brand-category-table-container{\n    height: calc(74vh - 8vh);\n    margin: 0px 10px;\n  }\n\n  .brand-category-table-container .MuiTableContainer-root {\n    height: auto !important;\n    min-height: calc(74vh - 8vh) !important;\n    max-height: 62vh !important;\n  }\n\n  .brand-category-table-container .MuiCheckbox-root {\n    z-index: 0;\n  }\n\n  .brand-category-table-container th {\n    text-align: center !important;\n    z-index: 0;\n  }\n\n  .brand-category-table-container td {\n    text-align: center !important;\n  }\n\n  .brand-category-table-container .MuiTableRow-root{\n    height: 10px !important;\n    border-left: 0px solid !important;\n  }\n\n  .brand-category-table-container .MuiTableHead-root{\n    height: 60px !important;\n  }\n\n  .mdc-chip{\n    padding: 0px 20px !important;\n    background-color: #FFFFFF!important;\n    color: #7F7F7F !important;\n    border: 1px solid #C4C4C4 !important;\n    border-radius: 40px !important;\n  } \n  \n  .mdc-chip--selected{\n    background-color: #7F7F7F !important;\n    color: #FFFFFF!important;\n  }\n\n  .brand-category-modal-form-header{\n    height: 6vh !important;\n    width: 100% !important;\n    border-bottom: 1px solid #C3C3C3 !important;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .brand-category-modal-form-header p {\n    padding: 1vh 0vh 0vh 1vh;\n    font-size: 2rem;\n    font-weight: 550;\n    margin: 0px;\n  }\n\n  .brand-category-modal-form-close-button{\n    margin: 1vh 1vh 0vh auto;\n    cursor: pointer\n  }\n\n  .brand-category-modal-form-body{\n    height: 71.5vh !important;\n    width: 100% !important;\n    padding-top: 2vh;\n  }\n\n  .brand-category-modal-form-footer{\n    height: 10vh;\n    width: 100% !important;\n    border-top: 1px solid #C3C3C3;\n    padding-top: 2vh;\n  }\n\n  .brand-category-modal-form-input-container{\n    height: 11.5vh !important;\n    width: 100% !important;\n    padding: 0.5vh 1vw 0vh 1vw;\n  }\n\n  .brand-category-modal-form-input-separator{\n    height: 4vh !important;\n    width: 100% !important;\n    padding: 0vh 1vw;\n    display: flex;\n  }\n\n  .brand-category-modal-form-input{\n    width: 15vw;\n  }\n  .brand-category-modal-form-input2{\n    width: 15vw;\n  }\n  .brand-category-modal-form-input p {\n    margin: 0px 0px 0px 1vh;\n    font-size: 1rem;\n    font-style: normal;\n    color: #7F7F7F;\n    font-weight: 600;\n  }\n\n  .brand-category-modal-form-note{\n    text-align: center;\n    background-color: #F2F2F2;\n    color: #000000 !important;\n    margin-top: 5.5vh !important;\n    word-spacing: 0.2vw;\n    margin-left: 37% !important;\n    margin-right: -41% !important;\n  }\n\n  .brand-category-text-input-box{\n    height: 5.3vh;\n    border: none;\n    width: 13.8vw;\n    font-size: 16px;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    resize: none;\n    background: #FFFFFF;\n    border: 1px solid #C4C4C4;\n    box-sizing: border-box;\n    border-radius: 4px;\n    padding: 1rem;\n  }\n\n  .brand-category-text-input-box:focus{\n    outline: 0;\n  }\n\n  .brand-category-text-suggest-input-box-container .wrapper {\n    z-index: auto !important;\n  }\n\n  .brand-category-text-suggest-input-box-container .sc-gsDKAQ {\n    z-index: 1!important;\n    background-color: #ffffff;\n    max-height: 15vh;\n    overflow: hidden;\n    overflow-y: scroll;\n  }\n\n\n  .brand-category-text-suggest-input-box-container .wrapper {\n    width: 13.8vw !important;\n  }\n\n  .brand-category-modal-form-input-separator-title{\n    margin: auto 0px;\n    align-items: center;\n    width: 20vw;\n    font-weight: 600;\n    padding-right: 1vw;\n  }\n\n  .brand-category-modal-form-input-separator-title p{\n    margin: 0px !important;\n    font-size: 2.5vh\n  }\n\n  .brand-category-modal-form-input-separator-line{\n    margin: auto 0px;\n    align-items: center;\n    width: 100%;\n    color: #7F7F7F;\n  }\n\n  .brand-category-form-modal-cancel-button{\n    margin: auto 2vh auto 2vh;\n    background-color: #F2F2F2;\n    border: none;\n    border-radius: 20px;\n    color: #7F7F7F;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 5vh;\n    width: 10vw;\n  }\n\n  .brand-category-form-modal-submit-button{\n    margin: auto 2vh auto 2vh;\n    background-color: #E61C2A;\n    border: none;\n    border-radius: 20px;\n    color: #F7F7F7;\n    text-align: center;\n    text-decoration: none;\n    font-size: small;\n    height: 5vh;\n    width: 10vw;\n  }\n\n  .brand-category-dialogue-icon-container{\n    justify-content: center;\n    text-align: center;\n    width: 42px;\n    border-radius: 500px;\n    height: 42px;\n    margin: auto;\n  }\n\n  .brand-category-dialogue-icon{\n    color: #9B9595;\n    height: 6vh;\n  }\n\n  .brand-category-dialogue-box-header{\n    font-weight: 600 !important;\n    color: #E61C2A;\n    text-align: center;\n    padding-top: 2vh;\n    \n  }\n\n  .brand-category-dialogue-box-description{\n    text-align: center;\n    width: 15vw;\n    margin: auto;\n  }\n\n  .brand-category-dialogue-box-input-box-container{\n    text-align: center;\n    margin: auto;\n  }\n\n  .brand-category-dialogue-box-input-box{\n    height: 10vh;\n    width: 20vw;\n    border-radius: 4px;\n    color: #606060;\n    font-family: inherit;\n    font-size: small;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    resize: none;\n  }\n\n  .brand-category-dialogue-box-input-box:focus{\n    outline: 0;\n  }\n\n  .brand-category-dialogue-button-container{\n    justify-content: center !important;\n    text-align: center;\n    padding-top: 1vh;\n  }\n\n  .brand-category-dialogue-button-submit{\n    background: #E61C2A !important;\n    border-radius: 35px !important;\n    height: 5vh !important;\n    width: 10vw !important;\n    color: white !important;\n    font-size: small !important;\n  }\n\n  .brand-category-dialogue-button-cancel{\n    background: #9B9595 !important;\n    border-radius: 35px !important;\n    height: 5vh !important;\n    width: 15vw !important;\n    color: white !important;\n    font-size: small !important;\n  }\n  \n.ch-ft{\n  width: 60.333333% !important;\n}\n.ch-act{\n  width: 38% !important;\n  margin-top: 12px !important;\n  margin-bottom: -5px;\n  margin-left: -103px; \n}\n\n.ch-btn{\n width: 18%;\n  float: right;\n  margin-right: -25px;\n  margin-left: 32px;\n}\n\n.ch-dp-dn{\n  height: 35px !important;\n}\n\n.ch-table{\n  margin: 0px 0px;\n  padding-top: 20px !important;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n\nbutton.ch-btn.brand-category-button.mt-3.col span.hover-button{\n  position: fixed;\n  width: 150px;\n  background: #5e5b5b;\n  padding: 15px 10px 0px 10px;\n  box-sizing: border-box;\n  border-radius: 5px;\n  visibility: hidden;\n  opacity: 0;\n  transform: translateX(-50px) translateY(-50px);\n}\nbutton.ch-btn.brand-category-button.mt-3.col span.hover-button::before{\n  content: '';\n  position: fixed;\n  width: 15px;\n  height: 15px;\n  background:#5e5b5b ;\n  top: -5px;\n  transform: rotate(45deg);\n}\nbutton.ch-btn.brand-category-button.mt-3.col:hover span.hover-button{\n  visibility: visible;\n  opacity: 1;\n  margin-left: -65px;\n  margin-top: 31px;\n  transform: translateX(-50px) translateY(0px);\n  z-index: 1;\n}\n\n\nbutton.tb-btn.ch-btn.brand-category-button.mt-3.col {\n  margin-right: 82%;\n  margin-left: 5px;\n  width: 80px;\n  margin-top: 1px !important;\n  height: 35px !important;\n  margin-bottom: -1%;\n}\n\n.sv-btn {\n  display:inline-flex;width:45%;\n}\n.ch-hm{\n  margin-top: 45px;\n}\n\n.rf-inp{\n  margin-right: 35px;\n  width: 45% !important;\n}\n.lf-rnp{\n  margin-left: 35px;\n  width: 45% !important;\n}\n\n.brand-category-modal-form-input.col-3.p-0.check-bx {\n  margin-top: -40px !important;\n  margin-bottom: 50px;\n  margin-left: 10px;\n}\n\n.imp-fl{\n  position: absolute;\n  font-size: 13px;\n  margin: 56px 26vw;\n  width: 200px;\n  height: 31px;\n  text-align: center;\n  border-radius: 12px;\n  padding-top: 5px;\n}\n.tb-ch{\n  margin-left: -3.8rem;\n    margin-top: 0.4rem;\n    max-width: 120% !important;\n    width: 110% !important;\n}\n.ant-table-thead{\n  font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n  font-size: 12px;\n}\n.ant-table-tbody{\n  font-size: 12px;\n  font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif;\n  font-weight: 400;\n  color: rgb(0 0 0) !important; \n};\n\n.ant-table-cell{\n  font-family: \"Roboto\",\"Helvetica\",\"Arial\",sans-serif !important;\n}\n\n  .ant-table-content{\n  zoom:0.89\n}\n.ant-table-filter-dropdown {\n  margin-top: -20px !important; \n} \n.ant-select-selection-item{\n  font-size: 11px !important;\n}\n.ant-select-selection-item-remove{\n  font-size: 6px !important;\n}\n.class-in-td{\n  font-weight: bold;\n}\n.ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child{\nbackground-color: #ffccc7;\n\n}\n\n.editable-cell {\n  position: relative;\n}\n\n.editable-cell-value-wrap {\n  padding: 5px 12px;\n  cursor: pointer;\n}\n\n.editable-row:hover .editable-cell-value-wrap {\n  padding: 4px 11px;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n}\n.ym-zw {\n  display:inline-flex;width:45%;\n}\n.bt-pc {\n  width: 89px;\n  height: 35px;\n  color: white;\n  }\n\n\n.tb-ch .ant-table-wrapper .ant-table-container table>thead>tr:first-child >* {\n  background-color: #424242;\n  color:white\n}\n\n.tb-ch .ant-table-wrapper .ant-table-container table>thead>tr:first-child >* .anticon {\n  color:white\n}\n.sc-btn.ch-act.col-2.brand-category-add-delete-export-button-container {\n  margin-left: 96%;\n  margin-top: -61px !important;\n  margin-bottom: 9px;\n  height: 93%;\n  display: block;\n  width: 5% !important;\n}\n\n.cst-hr{\n  width: 165px !important;\n}\n\n.fx-sv{\n  margin-top: -25px !important;\n  margin-left: 60px !important;\n}\n\n.hier.cst-hr.brand-category-dropdown-container {\n  width: 200px !important;\n}\n\ntbody>tr>td.ant-table-cell.country-column {\n  background-color: #E2E2E2;\n}\n\n.levels-img {\n  height: 25%;\n  width: 22%;\n  margin: 0px 0px 0px 40px;\n}\n.MuiTableCell-root .MuiTableCell-body .tableCellYouth .MuiTableCell-sizeSmall{\n  margin: 0px !important;\n  padding: 0px !important;\n}\n\n.pf-export-button{\n  background-color: #E61C2A;\n  border: none;\n  border-radius: 25px;\n  color: #F7F7F7;\n  text-align: center;\n  text-decoration: none;\n  font-size: small;\n  height: 80%;\n  width: 80%;\n  margin: 20px;\n}\n\n\n\n.brand-category-table-container-new .ant-table-wrapper .ant-table-container table>thead>tr:first-child >*:last-child{\n  background-color: #fff;\n  }\n\n.brand-category-table-container-new .dropdown-heading,\n.water-category-dropdown-container .dropdown-heading,\n.ci-category-dropdown-container .dropdown-heading{\n  background-color: #FFFFFF !important;\n  border-radius: 4px !important;\n  border: 1px solid #C4C4C4 !important;\n}\n\n.brand-category-multi-select-custom-new{\n  height: 50% !important;\n  width: 85% !important;\n  border-radius: 4px !important;\n  font-weight: 100;\n  font-size: small !important;\n  color: #000000 !important;\n  text-decoration: none !important;\n}\n\n.brand-category-multi-select-custom-new .dropdown-heading-value{\n  padding-left: 1vh;\n}\n\n.brand-category-add-delete-export-button-container{\n  padding: 0px !important;\n}\n\n\n\n.brand-category-export-button-w{\n  background-color: #9B9595;\n  border: none;\n  border-radius: 20px;\n  color: #F7F7F7;\n  text-align: center;\n  text-decoration: none;\n  font-size: small;\n  height: 60%;\n  width: 30%;\n  float: right;\n  margin-right: 35px;\n}\n\n.brand-category-body{\n  margin-top: 20px;\n  height: 100%;\n  width: 100%;\n  background-color: #FFFFFF;\n  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n}\n\n.brand-category-table-container-new .ant-table-row .ant-table-cell {\n  font-size: 17px;\n  font-weight: 100 !important;\n  padding: 10px !important;\n  font-family: -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji';\n  text-overflow: ellipsis !important;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: center;\n  \n}\n.brand-category-table-container-new .ant-table-thead >tr>th{\n  font-size: 15px !important;\n\n}\n\n.m-qrtr{\n  margin-top: 8px !important;\n  margin-left: 0px !important;\n  width: 179px;\n}\n\n.brand-background {\n  background-color: #e61c2a !important;\n}\n\n.ant-table-body {\n  overflow-y: auto !important;\n}\n\n#webpack-dev-server-client-overlay {\n  display: none !important;\n  pointer-events: none !important;\n}\n\n#webpack-dev-server-client-overlay-div {\n  display: none !important;\n  pointer-events: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
